import React, { useState, useEffect } from 'react';

const calculateTimeLeft = (targetDate) => {
  const difference = +new Date(targetDate) - +new Date();
  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  } else {
    timeLeft = { expired: true };
  }

  return timeLeft;
};

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(targetDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (timeLeft.expired) {
    return <div className="timer-expired">Webinar Started</div>;
  }

  return (
    <div className="countdown-timer">
      <div className="timer-item">
        <span className="timer-value">{String(timeLeft.days).padStart(2, '0')}</span>
        <span className="timer-label">Days</span>
      </div>
      <div className="timer-separator">:</div>
      <div className="timer-item">
        <span className="timer-value">{String(timeLeft.hours).padStart(2, '0')}</span>
        <span className="timer-label">Hours</span>
      </div>
      <div className="timer-separator">:</div>
      <div className="timer-item">
        <span className="timer-value">{String(timeLeft.minutes).padStart(2, '0')}</span>
        <span className="timer-label">Mins</span>
      </div>
      <div className="timer-separator">:</div>
      <div className="timer-item">
        <span className="timer-value">{String(timeLeft.seconds).padStart(2, '0')}</span>
        <span className="timer-label">Secs</span>
      </div>
    </div>
  );
};

export default CountdownTimer;
